import {BaseFormField} from "../../../../core/types/form-field.types";

export const releaseCalendarsResourceType = 'release-calendars'

export type DialogData = {
  data: ReleaseCalendarSelectedOptions | null;
}

export type MonthAndYear = {
  value: number;
  label: string;
};

export type ReleaseCalendarResult  = {
  data: ReleaseCalendarData
  releaseCalendarSelectedOptions: ReleaseCalendarSelectedOptions
}

export type ReleaseCalendarSelectedOptions = {
  month: number;
  year: number;
  monthName: string;
}

export type ReleaseCalendarQueryParams = {
  month: number;
  year: number;
  showAllTeams: boolean;
}

export type ReleaseCalendarFormField = BaseFormField & {
  options: MonthAndYear[];
}

export type ProductExpensesParams = {
  plannedDayPrice: number;
  plannedMonthPrice: number;
  productName: string;
}

export type ReleaseCalendarData = {
  products: Array<ReleaseCalendarProduct>;
  totalExpenses: number;
};

export type ReleaseCalendarProduct = {
  id: number;
  name: string;
  total: number;
  plannedDayPrice: number;
  plannedMonthPrice: number;
  productExpenses: Array<DayExpensesReleaseCalendar>;
  teams: Array<TeamReleaseCalendar>;
  planFactExceptions: Array<PlanFactException>;
}

export type TeamReleaseCalendar = {
  managers: Array<ManagerReleaseCalendar>;
  teamExpenses: Array<DayExpensesReleaseCalendar>;
  plannedDayPrice: number;
  plannedMonthPrice: number;
  reviewerName: string;
}

export type ManagerReleaseCalendar = {
  id: number;
  name: string;
  monthCount: number;
  monthPrice: number;
  plannedDayPrice: number;
  plannedMonthPrice: number;
  expenses: Array<DayExpensesReleaseCalendar>;
}

export type DayExpensesReleaseCalendar = {
  count: number;
  price: number;
  plannedDate: ReleaseCalendarPlannedDate;
  plannedPrice: number;
}

export type ReleaseCalendarPlannedDate = {
  0: number; //year
  1: number; //month
  2: number; //day
}

export type LimitCheckParams = {
  price: number;
  plannedPrice: number;
  planFactExceptionLimit?: number;
}

export type PlanFactException = {
  id: number;
  productId: number;
  date: string;
  dayLimit: number;
}

export type EditPlanDialogData = {
  planFactException: PlanFactException;
  plannedDayPrice: number;
}

export type EditPlanFactResult = {
  planFactException: PlanFactException;
  action: 'create' | 'update' | 'delete';
}

export type UpdateGroupStylesParams = {
  currentZoomOption: number;
  isMobile: boolean;
}
